
import React from 'react'
import img2045 from '../components/images/iebay.png'
import img2045a from '../components/images/ebay1.webp'
import img2045b from '../components/images/ebay2.webp'
import img2045c from '../components/images/ebay3.webp'
import img2045d from '../components/images/ebay4.webp'
const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2045} alt='ebay' />
            </div>
            <div className='container text-center'>
                <h2>Introduction To Ebay Ads</h2>
                <p>
                    eBay Ads are pivotal for boosting sales and elevating brand visibility on one of the largest global marketplaces. Through precise targeting options, eBay enables sellers to effectively connect with their target audience, optimizing campaigns to achieve maximum return on investment (ROI). Harnessing eBay Ads’ robust analytics provides strategic insights for continual marketing refinement, ensuring brands stay competitive in the dynamic e-commerce environment. Elevate your brand’s presence and impact by leveraging eBay Ads to reach millions of potential customers, driving growth and enhancing market reach.
                </p>
            </div>
            <div className='container'>
                <div className='row'>
                    <h2 className='text-center' >Display Ads</h2>
                    <div className='col'>
                        <ol>
                            <li>Display ads on eBay are a prominent ad format recognized for their presence in banner and sidebar placements. These ads are strategically positioned across eBay’s platform, leveraging both contextual and audience targeting to effectively reach your desired audience. Pricing for eBay display ads follows a CPM model (cost per one-thousand impressions), ensuring advertisers pay based on the number of times their ad is displayed. This approach optimizes visibility and engagement, making eBay display ads a versatile tool for connecting with your target market and enhancing brand visibility on the platform.
                            </li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2045a} alt='Queryimg' />
                    </div>
                </div >

                <div className='row'>
                    <h2 className='text-center' >Native Ads</h2>
                    <div className='col'>
                        <ol className="list-group-numbered">
                            Native ads on eBay seamlessly integrate into the platform’s user interface, blending with surrounding content to enhance user experience. These ads appear naturally across eBay, from sponsored results at the top of search pages to targeted marketing emails and homepage banners. Leveraging direct IO for programmatic advertising, eBay’s native ads are highly effective in engaging users without disrupting their browsing flow.

                            eBay offers sellers three distinct promotion tools to boost visibility and sales for their listings:

                            <li className="list-group-item">  eBay Promoted Listings Standard: This commission-based program increases clicks on promoted listings by up to 25%, helping sellers attract more views and potential buyers.</li>

                            <li className="list-group-item">  eBay Promoted Listings Advanced: Operating on a CPC (cost-per-click) basis, this program boosts sales by up to 40%. It enables sellers to optimize their advertising spend by paying only when customers click on their promoted listings.</li>

                            <li className="list-group-item">  eBay Promoted Listings Express: Designed for auction-style listings, this flat-fee advertising program enhances visibility on eBay’s platform. It provides sellers with a straightforward way to promote their auction items effectively.

                                These advertising tools empower sellers to strategically enhance their presence on eBay, drive traffic to their listings, and maximize their selling potential in a competitive marketplace.</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2045b} alt='Queryimg' />
                    </div>
                </div >
                <div className='row'>
                    <h2 className='text-center' >eBay Promotions</h2>
                    <div className='col'>
                        <ol className="list-group-numbered">
                            For eBay sellers subscribed to eBay Stores, eBay offers a comprehensive set of promotional tools known as Seller Hub Promotions. These tools are conveniently managed through the Seller Hub and are completely free of charge. They allow sellers to create enticing deals and promotions to attract potential buyers and boost sales. Integrated seamlessly with eBay advertising options, Seller Hub Promotions include:

                            <li className="list-group-item"> Order Size Discounts: Offer discounts when buyers purchase a specified minimum quantity of units, such as “Buy 5 units, get 15% off.”</li>

                            <li className="list-group-item">   Markdown Sale Events: Discount entire categories or custom inventory groups by a percentage, such as “25% off all wallets.”</li>

                            <li className="list-group-item">  Shipping Discounts: Provide free or discounted shipping under certain conditions, like “Free US shipping on orders over $30.”</li>

                            <li className="list-group-item">  Coded Coupons: Issue coupon codes for buyers to use at checkout, such as “Enter coupon code FIFTEENOFF for a 15% discount.”</li>

                            <li className="list-group-item">   Volume Pricing: Set discounts based on the purchase volume, for example, “10% off when buying 4 units, 15% off when buying 6 units.”</li>

                            <li className="list-group-item"> Offers to Buyers: Send personalized offers to buyers who have shown interest in your items, allowing negotiation through eBay’s offer system.</li>

                            These tools empower eBay sellers to effectively promote their listings, increase visibility, and engage potential buyers with attractive deals, all managed conveniently within the Seller Hub.


                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2045c} alt='Queryimg' />
                    </div>
                </div >
                <div className='row'>
                    <h2 className='text-center' >Classified Ads</h2>
                    <div className='col'>
                        <ol>
                            <li>Classified ads on eBay offer sellers a distinct way to list items by paying a flat fee to publish their ad and negotiate sales details off eBay’s platform. Ideal for services, real estate, or unique items like websites, these ads cater to items unsuitable for regular eBay listings. Listing fees vary by category and duration (30 or 90 days).

                                Promoted Listings Standard on eBay empower sellers to enhance visibility for specific items within eBay and across the eBay network. Sellers manage Promoted Listings Standard campaigns independently through their eBay selling accounts, boosting visibility for promoted items by up to 36% compared to non-promoted listings.</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2045d} alt='Queryimg' />
                    </div>
                </div>

            </div >

        </>
    )
}

export default events